'use client';

import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import { fetchAlerts } from '@commons/services/alert';

import AlertsBanner from './Banner';

/**
 * SiteAlerts component.
 *
 * Fetches the alerts on the server and renders a banner if there are any.
 */

const SiteAlerts = () => {
  const locale = useLocale();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['alerts', locale],
    queryFn: () => fetchAlerts(locale),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  if (isLoading || isError || !data || data.length === 0) {
    return null;
  }

  return <AlertsBanner alerts={data} />;
};

export default SiteAlerts;
